import { render, staticRenderFns } from "./DisplayFormatterTrend.vue?vue&type=template&id=405f1729&scoped=true"
import script from "./DisplayFormatterTrend.vue?vue&type=script&lang=js"
export * from "./DisplayFormatterTrend.vue?vue&type=script&lang=js"
import style0 from "./DisplayFormatterTrend.vue?vue&type=style&index=0&id=405f1729&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405f1729",
  null
  
)

export default component.exports